import { useRefinementList, UseRefinementListProps } from 'react-instantsearch-hooks-web';
import { COLOR_HEX_CONFIG } from 'helpers/constants/colors';
import { isLightColor } from './isLightColor';
import { Color } from 'components/commercetools-ui/organisms/product/product-list-colour';
interface Props extends UseRefinementListProps {
  transformItems?: (items: ReturnType<typeof useRefinementList>['items']) => any[];
  showMore?: boolean;
  limit?: number;
  showMoreLimit?: number;
  colors?: Color[];
}
export function ColourRefinementList({
  attribute,
  transformItems,
  showMore = true,
  limit = 100,
  showMoreLimit = 1000,
  colors,
}: Props) {
  const { items, refine, searchForItems, canRefine, canToggleShowMore, isShowingMore, toggleShowMore } =
    useRefinementList({
      attribute,
      limit,
      showMoreLimit,
      showMore,
      transformItems,
    });
  const colorsToCompare = colors ?? COLOR_HEX_CONFIG;
  const seenLabels = new Set<string>();

  const transformedItems = items
    .map((item) => {
      const label = item.label?.split(' > ')?.[1] || item.label;

      const matchedColor = colorsToCompare?.find((color) => color?.hex?.toLowerCase() === label?.toLowerCase());
      if (!matchedColor) return null;

      const lowerLabel = label?.toLowerCase();
      if (seenLabels.has(lowerLabel)) return null;

      seenLabels?.add(lowerLabel);

      return {
        ...item,
        label: matchedColor?.name,
        hex: matchedColor?.hex,
        hexArray: matchedColor?.hex?.includes('_') ? matchedColor?.hex?.split('_') : [matchedColor?.hex],
      };
    })
    .filter(Boolean)
    .sort((a, b) => a!.label.localeCompare(b!.label));

  return (
    <div className="flex flex-wrap justify-start gap-4">
      {transformedItems?.map((item) => {
        const isGradient = (item?.hexArray?.length ?? 0) > 1;
        const tickColor = item?.hexArray && isLightColor(item?.hexArray[0]) ? 'black' : 'white';
        return (
          <label
            key={item?.value}
            title={item?.label}
            className="relative h-[22px] w-[22px] cursor-pointer border border-[#dadada]"
            style={{
              backgroundImage: isGradient ? `linear-gradient(90deg, ${item?.hexArray?.join(',')})` : undefined,
              backgroundColor: item?.hex,
            }}
          >
            <input
              type="checkbox"
              checked={item?.isRefined}
              onChange={() => refine(item?.value ?? '')}
              className="sr-only"
            />
            {item?.isRefined && (
              <svg
                className="absolute left-1/2 top-1/2 h-[12px] w-[12px] -translate-x-1/2 -translate-y-1/2"
                viewBox="0 0 24 24"
                fill="none"
                stroke={tickColor || '#000'}
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
            )}
            <span className="sr-only">{item?.label}</span>
          </label>
        );
      })}
    </div>
  );
}
